import { Button } from "@mui/material";
import PropTypes from "prop-types";
import { styled } from '@mui/material/styles';

const Custombutton = styled(Button)(({ theme }) => ({
    backgroundColor: theme.palette.mode === 'dark' ? '#1A2027' : '#fff',
    ...theme.typography.body2,
    padding: theme.spacing(0.7),
    textAlign: 'center',
    color: theme.palette.text.secondary,
    fontFamily: "Customfont",
    border: " 1px solid #eee",
    fontWeight: 400,
    cursor: "pointer"

}));


export default function DefaultButton(props) {
    return (<Custombutton id='submit' onClick={e => props.onClick(e)} >{props.title}</Custombutton>)
}

DefaultButton.propTypes = {
    title: PropTypes.string,
}